import { render, staticRenderFns } from "./HostDashboardFaq.vue?vue&type=template&id=0e7fa4d5&"
import script from "./HostDashboardFaq.vue?vue&type=script&lang=js&"
export * from "./HostDashboardFaq.vue?vue&type=script&lang=js&"
import style0 from "./HostDashboardFaq.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HostDashboardFaq.vue"
export default component.exports